var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 124,
    viewBox: "0 0 98 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41852 88.6185C3.41852 88.6185 3.98972 85.4634 6.23589 92.8827C8.48205 100.302 33.881 116.54 42.383 103.389C50.8851 90.2386 62.9052 104.996 71.2085 101.049C79.5117 97.1019 80.8269 91.8931 74.6379 79.3421C68.4489 66.7911 83.673 51.4972 68.4973 41.6647C53.3216 31.8323 65.07 34.2478 65.07 34.2478L64.9927 74.3905L44.6786 92.8073L3.41852 88.6185Z",
    fill: "url(#paint0_linear_1032_13331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6476 49.5457C63.6476 49.5457 61.8831 49.443 65.7906 47.6927C69.6981 45.9424 76.8704 30.7461 69.1032 26.9218C61.3359 23.0974 68.5991 15.4253 65.8805 11.0861C63.1619 6.74693 60.2237 6.37096 53.7744 10.6576C47.3251 14.9443 34.8831 3.49501 30.5266 12.5835C26.17 21.6721 33.5701 10.6376 33.5701 10.6376L51.7154 16.3459L63.1594 26.3668L63.6476 49.5457Z",
    fill: "url(#paint1_linear_1032_13331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1032_13331",
    x1: 33.1587,
    y1: 110.414,
    x2: 64.2635,
    y2: 33.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC7677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE494B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_13331",
    x1: 73.5676,
    y1: 31.563,
    x2: 28.1094,
    y2: 19.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC7677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE494B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressborder);
export default __webpack_public_path__ + "static/media/progressborder.95038f897f86e9015a3b28697ddc3f73.svg";
export { ForwardRef as ReactComponent };